import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

const styles = () => ({
  appFrame: {
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    minHeight: "100vh",
  },
});

const AppFrame = ({ children, classes }) => (
  <div className={classes.appFrame}>{children}</div>
);

AppFrame.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppFrame);
